module.exports = __webpack_public_path__ + "media/ca-monopoly-demo.6ebf0df6.mp4";